import { CSSProperties, FC, useState } from 'react';
import { hapticFeedbackImpactOccurred } from '@telegram-apps/sdk-react';

import { useBackButtonToPrevRoute } from '@/hooks/useBackButtonToPrevRoute.tsx';
import { routes } from '@/navigation/routes.tsx';
import Header from '@/components/EarnTon/Header/Header.tsx';
import TabBar from '@/components/EarnTon/Tabbar/TabBar.tsx';
import Challenges from '@/components/EarnTon/Challenges/Challenges.tsx';
import History from '@/components/EarnTon/History/History.tsx';
import { useSkipDidMountEffect } from '@/hooks/useSkipDidMountEffect.ts';

const EarnTon: FC = () => {
  useBackButtonToPrevRoute(routes.profile);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  useSkipDidMountEffect(() => {
    hapticFeedbackImpactOccurred('rigid');
  }, [activeTabIndex]);

  return (
    <div style={containerStyle}>
      <Header />
      <TabBar
        activeTabIndex={activeTabIndex}
        setActiveTabIndex={setActiveTabIndex}
      />
      {activeTabIndex === 0 && <Challenges />}
      {activeTabIndex === 1 && <History />}
    </div>
  );
};

export default EarnTon;

const containerStyle: CSSProperties = {
  width: '100%',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column'
};
